export const tableInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id',
			direction: 'desc',
			className: 'id'
		},
		title: {
			index: 'title',
			title: 'Offer',
			direction: 'desc',
			className: 'title'
		},
		domain: {
			index: 'domain',
			title: 'Domain',
			direction: 'desc'
		},
		category: {
			index: 'category',
			title: 'Category',
			direction: 'desc'
		},
		category_rp: {
			index: 'category_rp',
			title: 'Category',
			direction: 'desc'
		},
		sale_model: {
			className: 'mid-col-1',
			index: 'sale_model',
			title: 'Model',
			direction: 'desc'
		},
		geo: {
			index: 'geo',
			title: 'Geo',
			direction: 'desc'
		},
		product_cap: {
			className: 'mid-col-1',
			index: 'product_cap',
			title: 'Prod cap',
			direction: 'desc'
		},
		leads_cap: {
			className: 'mid-col-1',
			index: 'leads_cap',
			title: 'Leads cap',
			direction: 'desc'
		},
		available_quantity: {
			className: 'mid-col',
			index: 'available_quantity',
			title: 'In stock',
			direction: 'desc'
		},
		remaining_quantity_in_days: {
			index: 'remaining_quantity_in_days',
			title: 'Days',
			direction: 'desc'
		},
		actions: {
			title: 'Actions'
		}
	},
	sortByColumn: {
		index: 'display_priority',
		direction: 'desc'
	},
	rowsNumber: 1000
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/index.js